import banksOptions from '@/core/data/banks.js';

const CustomerStatus = {
  ACTIVE: {
    key: 1,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: 2,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const CustomerHasBoughtValues = {
  YES: {
    key: true,
    label: "SI",
  },
  NOT: {
    key: false,
    label: "No",
  },
};

const ProductsStatus = {
  ACTIVE: {
    key: 1,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: 2,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const StockProductsValues = {
  YES: {
    key: true,
    label: "SI",
  },
  NOT: {
    key: false,
    label: "No",
  },
};

// Filtro de estado de stock del listado de productos (StockStatus en el backend)
const StockStatus = {
  IN_STOCK: {
    key: "IN_STOCK",
    label: "Con stock",
  },
  LOW_STOCK: {
    key: "LOW_STOCK",
    label: "Stock bajo",
  },
  OUT_OF_STOCK: {
    key: "OUT_OF_STOCK",
    label: "Agotado",
  },
  NEGATIVE_STOCK: {
    key: "NEGATIVE_STOCK",
    label: "Stock negativo",
  },
};

const ImageProductsValues = {
  YES: {
    key: true,
    label: "SI",
  },
  NOT: {
    key: false,
    label: "No",
  },
};

const DescriptionProductsValues = {
  YES: {
    key: true,
    label: "SI",
  },
  NOT: {
    key: false,
    label: "No",
  },
}

const UsersStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const CategoriesStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const UsersProfileValues = {
  ADMINISTRATOR: {
    key: "ADMINISTRATOR",
    label: "ADMINISTRADOR",
  },
  SALES: {
    key: "SALES",
    label: "VENTAS",
  },
  WAREHOUSE: {
    key: "WAREHOUSE",
    label: "ALMACÉN",
  },
};

const StoreStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const StoreTypes = {
  BOUTIQUE: {
    key: 1,
    label: "Boutique",
  },
  MINIMARKET: {
    key: 2,
    label: "Minimarket",
  },
};

const BooleanValues = {
  YES: {
    key: true,
    label: "SI",
  },
  NOT: {
    key: false,
    label: "NO",
  },
};

const PaymentMethods = {
  WIRE_TRANSFER: {
    key: "WIRE_TRANSFER",
    label: "Depósito bancario",
  },
  IZIPAY: {
    key: "IZIPAY",
    label: "Izipay",
    logo: "izipay.png",
  },
  NIUBIZ: {
    key: "NIUBIZ",
    label: "Niubiz",
    logo: "niubiz.png",
  },
  CULQI: {
    key: "CULQI",
    label: "Culqi",
    logo: "culqi.png",
  },
  UPON_DELIVERY: {
    key: "UPON_DELIVERY",
    label: "Contra entrega con efectivo",
  },
  UPON_DELIVERY_POS: {
    key: "UPON_DELIVERY_POS",
    label: "Contra entrega con POS",
  },
  LINK: {
    key: "LINK",
    label: "Link de pago",
  },
  YAPE: {
    key: "YAPE",
    label: "Yape",
    logo: "yape.png",
  },
  PLIN: {
    key: "PLIN",
    label: "Plin",
    logo: "plin.png",
  },
  PAGO_EFECTIVO: {
    key: "PAGO_EFECTIVO",
    label: "PagoEfectivo",
    logo: "pago-efectivo.png",
  }
}

const BankAccountTypes = {
  SAVINGS_ACCOUNT: {
    key: 1,
    label: "Cuenta de Ahorros Soles"
  },
  CURRENT_ACCOUNT: {
    key: 2,
    label: "Cuenta Corrientes Soles"
  }
}

const BanksOptions = banksOptions

const ProductsAttributes = {
  LIST: {
    key: 1,
    label: "Lista desplegable",
  },
  COLOR: {
    key: 2,
    label: "Color",
  },
  RADIO: {
    key: 3,
    label: "Radio buttons",
  },
  TEXTURE: {
    key: 4,
    label: "Texture",
  },
};

const ProductsAttributesStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const ProviderStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const BannersRedirectTypes = {
  CATEGORY: {
    key: 1,
    label: "Categoría",
  },
  PRODUCT: {
    key: 2,
    label: "Producto",
  },
  OTHER: {
    key: 3,
    label: "Otro",
  },
};

const BannersStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const BannerTypes = {
  TIPO_1: {
    key: 1
  },
  TIPO_2: {
    key: 2
  }
}

const OrdersStatus = {
  PENDING: {
    key: "PENDING",
    label: "PENDIENTE",
    color: "badge-gray",
  },
  DELIVERED: {
    key: "DELIVERED",
    label: "ENTREGADO",
    color: "badge-green",
  },
  CANCELLED: {
    key: "CANCELLED",
    label: "ANULADO",
    color: "badge-red",
  },
  REJECTED: {
    key: "REJECTED",
    label: "RECHAZADO",
    color: "badge-red",
  },
  PAYMENT_CONFIRMED: {
    key: "PAYMENT_CONFIRMED",
    label: "PAGO CONFIRMADO",
    color: "badge-yellow",
  },
};

const BiolinkBlockTypes = [
  {
    key: "BUTTON_OR_CARD",
    label: "Card con imagen",
  },
];

const TimeRangeOptions = [
  {
    key: "00:00",
    label: "00:00",
  },
  {
    key: "00:30",
    label: "00:30",
  },
  {
    key: "01:00",
    label: "01:00",
  },
  {
    key: "01:30",
    label: "01:30",
  },
  {
    key: "02:00",
    label: "02:00",
  },
  {
    key: "02:30",
    label: "02:30",
  },
  {
    key: "03:00",
    label: "03:00",
  },
  {
    key: "03:30",
    label: "03:30",
  },
  {
    key: "04:00",
    label: "04:00",
  },
  {
    key: 7,
    label: "07:00",
  },
  {
    key: 9,
    label: "09:00",
  },
];

const addressTypes = [
  { key: 1, label: "Casa" },
  { key: 2, label: "Departamento" },
  { key: 3, label: "Condominio" },
  { key: 4, label: "Residencial" },
  { key: 5, label: "Oficina" },
  { key: 6, label: "Galería" },
  { key: 7, label: "Otro" },
];

const Plans = [
  { key: 'BASIC', label: "Plan Gratis" },
  { key: 'PRO', label: "Plan Impulso" },
  { key: 'BUSINESS', label: "Plan Ascenso" },
  { key: 'ENTERPRISE', label: "Plan Cumbre" }
];


const Genders = {
  MALE: { key: 1, label: 'HOMBRE' },
  FEMALE: { key: 2, label: 'MUJER' },
  OTHER: { key: 3, label: 'OTRO' },
  RATHER_NOT_SAY: { key: 4, label: 'PREFIERO NO DECIRLO' }
};

const ShippingTypes = {
  INDEPENDENT: {
    key: 1,
    label: 'Independiente'
  },
  COURIER: {
    key: 2,
    label: 'Courier'
  }
}

const DeliveryDaysOptions = {
  FIXED_DAYS: {
    key: 1,
    label: 'Días fijos'
  },
  BUSINESS_DAYS: {
    key: 2,
    label: 'Días hábiles'
  }
}

const ContactOptions = {
  CALL: { key: 1, label: 'Por llamada' },
  WHATSAPP: { key: 2, label: 'Por whatsapp' },
  EMAIL: { key: 3, label: 'Por email' }
}

const QuoteStatus = {
  DRAFT: {
    key: 'DRAFT',
    label: "BORRADOR",
    color: "badge-blue"
  },
  GENERATED: {
    key: 'GENERATED',
    label: "GENERADO",
    color: "badge-green"
  },
};

const RedirectionsOptions = {
  MOVED_PERMANENTLY: {
    key: 'MOVED_PERMANENTLY',
    label: '301 - Movido permanentemente'
  },
  FOUND: {
    key: 'FOUND',
    label: '302 - Encontrado'
  },
  TEMPORARY_REDIRECT: {
    key: 'TEMPORARY_REDIRECT',
    label: '307 - Redirección temporal'
  },
  GONE: {
    key: 'GONE',
    label: '410 - Contenido eliminado'
  },
  UNAVAILABLE_FOR_LEGAL_REASONS: {
    key: 'UNAVAILABLE_FOR_LEGAL_REASONS',
    label: '451 - No disponible por motivos legales'
  }
}

const AnnouncementBarStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

const CouponType = {
  PERCENTAGE: { key: "PERCENTAGE", label: "Porcentaje" },
  FIXED_AMOUNT: { key: "FIXED_AMOUNT", label: "Monto fijo" },
  FREE_SHIPPING: { key: "FREE_SHIPPING", label: "Envío gratis" },
};

const CouponScope = {
  ALL: { key: "ALL", label: "Toda la tienda" },
  CATEGORIES: { key: "CATEGORIES", label: "Categorías específicas" },
  PRODUCTS: { key: "PRODUCTS", label: "Productos específicos" },
  BRANDS: { key: "BRANDS", label: "Marcas específicas" },
};

const CouponStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
};

// Portada configurable (DEF-007): tipos de sección con su icono (Remix Icon)
const HomeSectionTypes = {
  BANNERS: { key: "BANNERS", label: "Banners", icon: "ri-image-line", description: "Imágenes con texto y enlace" },
  PRODUCTS: { key: "PRODUCTS", label: "Productos", icon: "ri-shopping-cart-line", description: "Manuales, por categoría, más vendidos o recientes" },
  CATEGORIES: { key: "CATEGORIES", label: "Categorías", icon: "ri-layout-grid-line", description: "Accesos a categorías con su imagen" },
  BRANDS: { key: "BRANDS", label: "Marcas", icon: "ri-price-tag-3-line", description: "Logos de marcas" },
  FREE_TEXT: { key: "FREE_TEXT", label: "Texto libre", icon: "ri-text", description: "Contenido HTML" },
  COUPON_BAR: { key: "COUPON_BAR", label: "Barra de cupón", icon: "ri-coupon-3-line", description: "Mensaje destacado con un código" },
  SEPARATOR: { key: "SEPARATOR", label: "Separador", icon: "ri-separator", description: "Espacio entre secciones" },
};

const HomeDisplayModes = {
  STATIC: { key: "STATIC", label: "Estático" },
  CAROUSEL: { key: "CAROUSEL", label: "Carrusel" },
};

const HomeProductSources = {
  MANUAL: { key: "MANUAL", label: "Manual" },
  CATEGORY: { key: "CATEGORY", label: "Por categoría" },
  BEST_SELLERS: { key: "BEST_SELLERS", label: "Más vendidos" },
  NEWEST: { key: "NEWEST", label: "Más recientes" },
};

// Estado de las páginas estáticas (post.status): 1 = publicada, 2 = borrador
const PostStatus = {
  PUBLISHED: { key: 1, label: "PUBLICADO", color: "badge-green" },
  DRAFT: { key: 2, label: "BORRADOR", color: "badge-yellow" },
};

const HomeLinkTypes = {
  EXTERNAL: { key: "EXTERNAL", label: "URL" },
  CATEGORY: { key: "CATEGORY", label: "Categoría" },
  PRODUCT: { key: "PRODUCT", label: "Producto" },
  PAGE: { key: "PAGE", label: "Página" },
};

export default {
  CustomerStatus,
  CustomerHasBoughtValues,
  ProductsStatus,
  StockProductsValues,
  StockStatus,
  HomeSectionTypes,
  HomeDisplayModes,
  HomeProductSources,
  HomeLinkTypes,
  PostStatus,
  ImageProductsValues,
  UsersStatus,
  UsersProfileValues,
  StoreStatus,
  StoreTypes,
  BooleanValues,
  CategoriesStatus,
  ProductsAttributes,
  ProductsAttributesStatus,
  ProviderStatus,
  BannersRedirectTypes,
  BannersStatus,
  BannerTypes,
  OrdersStatus,
  BiolinkBlockTypes,
  TimeRangeOptions,
  addressTypes,
  Genders,
  ShippingTypes,
  DeliveryDaysOptions,
  PaymentMethods,
  BankAccountTypes,
  BanksOptions,
  ContactOptions,
  QuoteStatus,
  RedirectionsOptions,
  Plans,
  AnnouncementBarStatus,
  DescriptionProductsValues,
  CouponType,
  CouponScope,
  CouponStatus
};
